import { AgResourceLanguage } from '../types';
import { banners as EnUsBanner } from '../en-us/banners';

export const banners: AgResourceLanguage['banners'] = {
  ...EnUsBanner,
  gift: {
    title: 'Stuur een cadeau naar vrienden en familie',
    description:
      'Nu kunnen jouw dierbaren AG1 proberen met het cadeau van dagelijkse Fundamentele Voeding.',
    iconAccessibleName: 'Cadeau',
    imageAccessibleName: 'Cadeau',
    buttonCloseLabel: 'Sluiten',
    buttonShopLabel: 'Koop Cadeaus'
  },
  paymentMethod: {
    title: 'Ontbrekende betaalmethode',
    description:
      'Voeg een betaalmethode toe aan je abonnement om door te gaan met het ontvangen van abonnementsbestellingen.',
    addCtaBtnLabel: 'Voeg Nu Toe',
    updateCtaBtnLabel: 'Werk Nu Bij'
  },
  stockBanner:
    'Producten in je volgende zending zijn momenteel niet op voorraad en worden niet verzonden. Niet op voorraad zijnde items zijn uitgesloten van je ordertotaal.',
  upcomingOrderBanner: {
    preparing: 'Wordt voorbereid',
    shipped: 'Verzonden',
    delivered: 'Afgeleverd',
    preparingDescription: 'We zijn bezig met de voorbereiding van je bestelling.',
    shippedDescription: 'Je huidige bestelling is onderweg.',
    deliveredDescription: 'Hoera! Je hebt AG1 ontvangen.',
    orderDetailsLink: 'Bekijk Bestellingsdetails',
    trackingLink: 'Bekijk Volgstatus'
  },
  cookies: {
    text: 'We gebruiken cookies van derden en trackingtechnologieën die informatie verzamelen over je gebruik van de site. Deze derden kunnen je informatie voor hun eigen doeleinden gebruiken, zoals beschreven in ons ',
    link: 'Privacybeleid.'
  },
  promotionalBanner: {
    promotionMessage: 'Geweldige waarde',
    title: 'Meer van het goede',
    descriptionPart1: 'Wijzig je abonnement naar 2 zakken en krijg ze elk voor €74,50 ',
    descriptionPart2:
      ' — perfect voor stellen, gezinnen en zeer actieve leden die elke dag een tweede schepje AG1 willen.',
    disclaimerFull:
      'Het is altijd het beste om met je zorgverlener te overleggen om te bepalen welke voedingsmix het beste voor je is.',
    disclaimerShort: 'Raadpleeg je zorgverlener om het beste voedingsniveau voor jou te bepalen.',
    buttonText: 'Voeg Een Zak Toe'
  },
  offerSoldOut: 'Dit aanbod is uitverkocht',
  offerVariantsSoldOut: {
    soldOut_one: '{{soldOutProducts}} is uitverkocht',
    soldOut_other: '{{soldOutProducts}} zijn uitverkocht'
  }
};
